/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/search.js ***!
  \**************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function debounce(fn, wait) {
  var _this = this;

  var t;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(t);
    t = setTimeout(function () {
      return fn.apply(_this, args);
    }, wait);
  };
}

var PredictiveSearch = /*#__PURE__*/function (_HTMLElement) {
  _inherits(PredictiveSearch, _HTMLElement);

  var _super = _createSuper(PredictiveSearch);

  function PredictiveSearch() {
    var _this2;

    _classCallCheck(this, PredictiveSearch);

    _this2 = _super.call(this);
    _this2.cachedResults = {};
    _this2.input = _this2.querySelector('input[type="search"]');
    _this2.predictiveSearchResults = _this2.querySelector('[data-predictive-search]');
    _this2.trendingAndProductsBlock = _this2.querySelector('[data-quick-trending-products]');
    _this2.closeStickySearchButton = document.querySelector('[data-search-close]');
    _this2.productToShow = _this2.dataset.productToShow;
    _this2.searchDetails = _this2.querySelector('details.search_details');
    _this2.isOpen = false;

    _this2.setupEventListeners();

    return _this2;
  }

  _createClass(PredictiveSearch, [{
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this3 = this;

      var form = this.querySelector('form.search');
      form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.addEventListener('input', debounce(function (event) {
        _this3.onChange(event);
      }, 500).bind(this));
      this.input.addEventListener('focus', this.onFocus.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.addEventListener('keyup', this.onKeyup.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
      document.addEventListener('click', this.onDocClick.bind(this));
      this.closeStickySearchButton.addEventListener('click', this.onCloseStickySearchClick.bind(this));
    }
  }, {
    key: "getQuery",
    value: function getQuery() {
      return this.input.value.trim();
    }
  }, {
    key: "onChange",
    value: function onChange() {
      var searchTerm = this.getQuery();

      if (!searchTerm.length) {
        this.close(true);
        return;
      }

      this.getSearchResults(searchTerm);
    }
  }, {
    key: "onFormSubmit",
    value: function onFormSubmit(event) {
      if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      var searchTerm = this.getQuery();
      if (!searchTerm.length) return this.showTrendingAndProducts();

      if (this.getAttribute('results') === 'true') {
        this.open();
      } else {
        this.getSearchResults(searchTerm);
      }
    }
  }, {
    key: "onFocusOut",
    value: function onFocusOut() {
      var _this4 = this;

      setTimeout(function () {
        if (!_this4.contains(document.activeElement)) {
          _this4.close();

          _this4.hideTrendingAndProducts();
        }

        ;
      });
    }
  }, {
    key: "onKeyup",
    value: function onKeyup(event) {
      if (!this.getQuery().length) {
        this.close(true);
        this.showTrendingAndProducts();
      }

      ;
      event.preventDefault();

      switch (event.code) {
        case 'ArrowUp':
          this.switchOption('up');
          break;

        case 'ArrowDown':
          this.switchOption('down');
          break;

        case 'Enter':
          this.selectOption();
          break;
      }
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(event) {
      // Prevent the cursor from moving in the input when using the up and down arrow keys
      if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
        event.preventDefault();
      }
    }
  }, {
    key: "switchOption",
    value: function switchOption(direction) {
      if (!this.getAttribute('open')) return;
      var moveUp = direction === 'up';
      var selectedElement = this.querySelector('[aria-selected="true"]');
      var allElements = this.querySelectorAll('li');
      var activeElement = this.querySelector('li');
      if (moveUp && !selectedElement) return;
      this.statusElement.textContent = '';

      if (!moveUp && selectedElement) {
        activeElement = selectedElement.nextElementSibling || allElements[0];
      } else if (moveUp) {
        activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
      }

      if (activeElement === selectedElement) return;
      activeElement.setAttribute('aria-selected', true);
      if (selectedElement) selectedElement.setAttribute('aria-selected', false);
      this.setLiveRegionText(activeElement.textContent);
      this.input.setAttribute('aria-activedescendant', activeElement.id);
    }
  }, {
    key: "selectOption",
    value: function selectOption() {
      var selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');
      if (selectedProduct) selectedProduct.click();
    }
  }, {
    key: "getSearchResults",
    value: function getSearchResults(searchTerm) {
      var _this5 = this;

      var queryKey = searchTerm.replace(" ", "-").toLowerCase();
      this.setLiveRegionLoadingState();

      if (this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        this.updateViewAllLink(searchTerm);
        return;
      }

      console.log(this.updateViewAllLink(searchTerm));
      fetch("".concat(routes.predictive_search_url, "?q=").concat(encodeURIComponent(searchTerm), "&").concat(encodeURIComponent('resources[type]'), "=product&").concat(encodeURIComponent('resources[limit]'), "=").concat(this.productToShow, "&section_id=predictive-search")).then(function (response) {
        if (!response.ok) {
          var error = new Error(response.status);

          _this5.close();

          throw error;
        }

        return response.text();
      }).then(function (text) {
        var resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        _this5.cachedResults[queryKey] = resultsMarkup;

        _this5.renderSearchResults(resultsMarkup);

        _this5.updateViewAllLink(searchTerm);
      })["catch"](function (error) {
        _this5.close();

        throw error;
      });
    }
  }, {
    key: "setLiveRegionLoadingState",
    value: function setLiveRegionLoadingState() {
      this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
      this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
      this.setLiveRegionText(this.loadingText);
      this.setAttribute('loading', true);
    }
  }, {
    key: "setLiveRegionText",
    value: function setLiveRegionText(statusText) {
      var _this6 = this;

      this.statusElement.setAttribute('aria-hidden', 'false');
      this.statusElement.textContent = statusText;
      setTimeout(function () {
        _this6.statusElement.setAttribute('aria-hidden', 'true');
      }, 1000);
    }
  }, {
    key: "renderSearchResults",
    value: function renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.setAttribute('results', true);
      this.setLiveRegionResults();
      this.open();
      this.hideTrendingAndProducts();
    }
  }, {
    key: "setLiveRegionResults",
    value: function setLiveRegionResults() {
      this.removeAttribute('loading');
      this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
    }
  }, {
    key: "getResultsMaxHeight",
    value: function getResultsMaxHeight() {
      this.resultsMaxHeight = window.innerHeight - document.querySelector('[id^="shopify-section-header"]').getBoundingClientRect().bottom;
      return this.resultsMaxHeight;
    }
  }, {
    key: "open",
    value: function open() {
      this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || "".concat(this.getResultsMaxHeight(), "px");
      this.setAttribute('open', true);
      this.input.setAttribute('aria-expanded', true);
      this.isOpen = true;
      this.searchDetails.setAttribute('open', true);
    }
  }, {
    key: "close",
    value: function close() {
      var clearSearchTerm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (clearSearchTerm) {
        this.input.value = '';
        this.removeAttribute('results');
      }

      var selected = this.querySelector('[aria-selected="true"]');
      if (selected) selected.setAttribute('aria-selected', false);
      this.input.setAttribute('aria-activedescendant', '');
      this.removeAttribute('open');
      this.input.setAttribute('aria-expanded', false);
      this.resultsMaxHeight = false;
      this.predictiveSearchResults.removeAttribute('style');
      this.isOpen = false;
      this.searchDetails.removeAttribute('open', true);
    }
  }, {
    key: "showTrendingAndProducts",
    value: function showTrendingAndProducts() {
      if (!this.trendingAndProductsBlock) return;
      this.trendingAndProductsBlock.classList.add('is-show');
      this.trendingAndProductsBlock.classList.remove('hidden');
    }
  }, {
    key: "hideTrendingAndProducts",
    value: function hideTrendingAndProducts() {
      if (!this.trendingAndProductsBlock) return;
      this.trendingAndProductsBlock.classList.remove('is-show');
      this.trendingAndProductsBlock.classList.add('hidden');
    }
  }, {
    key: "onDocClick",
    value: function onDocClick(e) {
      var closeButton;

      if (e.target.matches('.header-search-popup-close') || e.target.matches('.header-search-close')) {
        closeButton = e.target;
      } else if (e.target.closest('.header-search-popup-close')) {
        closeButton = e.target.closest('.header-search-popup-close');
      } else if (e.target.closest('.header-search-close')) {
        closeButton = e.target.closest('.header-search-close');
      }

      var isInModal = this.contains(e.target);
      if (isInModal && !closeButton) return;
      this.close();
      this.hideTrendingAndProducts();
    }
  }, {
    key: "onCloseStickySearchClick",
    value: function onCloseStickySearchClick() {
      this.close();
      this.hideTrendingAndProducts();
      document.querySelector('body').classList.remove('sticky-search-open');
    }
  }, {
    key: "updateViewAllLink",
    value: function updateViewAllLink(searchTerm) {
      var qsViewAllLink = document.querySelector('[data-qs-view-all-link]');
      if (!qsViewAllLink) return;
      var linkTotal = "".concat(routes.search_url, "?q=").concat(encodeURIComponent(searchTerm), "&").concat(encodeURIComponent('resources[type]'), "=product");
      qsViewAllLink.href = linkTotal;
      return this.getTotalResults(linkTotal).then(function (count) {
        qsViewAllLink.innerHTML = qsViewAllLink.innerHTML.replace('()', "(".concat(count, ")"));
      });
    }
  }, {
    key: "getTotalResults",
    value: function getTotalResults(url) {
      var _this7 = this;

      return fetch(url).then(function (response) {
        if (!response.ok) {
          var error = new Error(response.status);

          _this7.close();

          throw error;
        }

        return response.text();
      }).then(function (text) {
        var totalCount = new DOMParser().parseFromString(text, 'text/html').querySelector('[id^="SearchSection"]').dataset.searchCount;
        return totalCount;
      })["catch"](function (error) {
        _this7.close();

        throw error;
      });
    }
  }]);

  return PredictiveSearch;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('predictive-search', PredictiveSearch);
/******/ })()
;